'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingItem", {
    enumerable: true,
    get: function() {
        return RatingItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useRatingItem = require("./useRatingItem");
const _renderRatingItem = require("./renderRatingItem");
const _useRatingItemStylesstyles = require("./useRatingItemStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const RatingItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useRatingItem.useRatingItem_unstable)(props, ref);
    (0, _useRatingItemStylesstyles.useRatingItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useRatingItemStyles_unstable')(state);
    return (0, _renderRatingItem.renderRatingItem_unstable)(state);
});
RatingItem.displayName = 'RatingItem';
